<template>
  <div>
    <div class="form-check custom-control">
      <label>
         <input type="checkbox" class="form-check-input mr-1" v-model="isSelectAll"
               @change="selectAllChanged"/>
        <span> Select All </span>
      </label>

    </div>
    <div class="form-check custom-control" v-for="user in allUsers" :key="user.staffId">
      <label>
      
        <input type="checkbox" class="form-check-input mr-1" v-model="selectedUsers" :value="user"
               @change="userChanged"/>

        <input type="text" class="form-control rounded-0 form-control-md" v-if="includeOther && user.staffId === 0"
               v-model="user.staffFirstName" @blur="userChanged"/>
        <span v-else> {{ user.staffFirstName }}  {{ user.staffLastName }}</span>
      </label>

    </div>

  </div>
</template>

<script>
import StaffService from '../services/staffservice';
import {nextTick, onMounted, ref, toRefs, watch} from 'vue';

export default {
  name: 'Users',
  props: {
    farm: String,
    users: Array,
    includeOther: Boolean,
    staffInvolvement: String
  },
  emit: ['userChecked'],
  setup(props) {
    const {farm, users, includeOther, staffInvolvement} = toRefs(props);

    const selectedUsers = ref([]);
    const allUsers = ref([]);
    const staffService = StaffService;
    const isSelectAll = ref(false);

    //watch, we should load all the staff if the farm changes
    const farmChanged = async () => {

      await loadStaff();

    };

    //mounted
    const loadStaff = async () => {

      const staffResults = await staffService.getStaff(farm.value !== undefined ? farm.value : '');

      await nextTick(() => {
        allUsers.value.splice(0);
        staffResults.forEach(s => allUsers.value.push(Object.assign({staffInvolvement: staffInvolvement !== undefined ? staffInvolvement.value : ''}, s)));

        if (includeOther.value) {
          allUsers.value.push({
            staffId: 0,
            name: 'Other',
            staffInvolvement: staffInvolvement !== undefined ? staffInvolvement.value : ''
          });
        }

        setupStaff();
      });
    };

    const setupStaff = () => {

      if (users.value != null && users.value.length > 0) {
        selectedUsers.value.splice(0);

        users.value.forEach(user => {
          const foundUser = allUsers.value.find(f => f.staffId == user.staffId);
          if (foundUser) {
            if (foundUser.staffId === 0) {
              foundUser.staffFirstName = user.staffFirstName;
            }
            selectedUsers.value.push(foundUser);
          }
        });

        adjustSelectAllState();
      }
    }

    const adjustSelectAllState = () => {
       //If selectAll feature is turned on and we have the same amount of users as the total users, set the select all to true
        let usersCount = includeOther.value ? allUsers.value.length - 1: allUsers.value.length;
        isSelectAll.value = selectedUsers.value.length == usersCount;
        
    }

    watch(farm, farmChanged);

    onMounted(loadStaff);

    return {
      allUsers,
      selectedUsers,
      isSelectAll,
      setupStaff,
      adjustSelectAllState
    }
  },
  methods: {
    userChanged() {
      this.adjustSelectAllState();
      this.$emit('userChecked', this.selectedUsers);
    },
    selectAllChanged() {
      this.selectedUsers.splice(0);
   
      if (this.isSelectAll) {
        
        this.allUsers.forEach(s => {
          if (s.staffId > 0) {
            this.selectedUsers.push(s);
          }
        });
      }
      this.userChanged();
     
    }
  }
}
</script>